export const SET_COMMUNITIES_LIST = 'SET_COMMUNITIES_LIST';
export const SET_ACTIVE_COMMUNITY = 'SET_ACTIVE_COMMUNITY';
export const SET_ACTIVE_COMMUNITY_USER = 'SET_ACTIVE_COMMUNITY_USER';
export const SET_ASIDE_POSTS = 'SET_ASIDE_POSTS';
export const SET_ASIDE_POSTS_COUNTER = 'SET_ASIDE_POSTS_COUNTER';
export const APPEND_ASIDE_POST = 'APPEND_ASIDE_POST';
export const APPEND_POSTS = 'APPEND_POSTS';
export const SET_POSTS = 'SET_POSTS';
export const SET_POSTS_COUNTER = 'SET_POSTS_COUNTER';
export const ADD_COMMENT_TO_LIST = 'ADD_COMMENT_TO_LIST';
export const SET_ACTIVE_POST = 'SET_ACTIVE_POST';
export const APPEND_POST_COMMENTS = 'APPEND_POST_COMMENTS';
export const SET_POST_COMMENTS = 'SET_POST_COMMENTS';
export const SET_POST_COMMENTS_COUNTER = 'SET_POST_COMMENTS_COUNTER';
export const SET_REPLIES_TO_COMMENT = 'SET_REPLIES_TO_COMMENT';
export const SET_ACTIVE_COMMENT = 'SET_ACTIVE_COMMENT';
export const RESET_ACTIVE_COMMENT = 'RESET_ACTIVE_COMMENT';
export const SET_ACTIVE_COMMUNITY_TERMS = 'SET_ACTIVE_COMMUNITY_TERMS';
export const UPDATE_POST_LIST = 'UPDATE_POST_LIST';
export const UPDATE_POST_COMMENT_ON_LIST = 'UPDATE_POST_COMMENT_ON_LIST';
export const UPDATE_POST_ON_LIST = 'UPDATE_POST_ON_LIST';
export const UPDATE_POST_ON_ASIDE_LIST = 'UPDATE_POST_ON_ASIDE_LIST';
export const UPDATE_REPLY_ON_LIST = 'UPDATE_REPLY_ON_LIST';
export const ADD_REPLY_ON_LIST = 'ADD_REPLY_ON_LIST';
export const SET_TAGS = 'SET_TAGS';
export const SET_POPULAR_TAGS = 'SET_POPULAR_TAGS';
export const SET_TAG_FILTER = 'SET_TAG_FILTER';
export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
export const SET_MODERATION_STATE_FILTER = 'SET_MODERATION_STATE_FILTER';
export const TOGGLE_MODERATION_STATE_FILTER = 'TOGGLE_MODERATION_STATE_FILTER';
export const RESET_POST_FILTER = 'RESET_POST_FILTER';
export const SET_POST_UPLOAD = 'SET_POST_UPLOAD';
export const RESET_POST_UPLOAD = 'RESET_POST_UPLOAD';
export const SET_POST_IMAGE = 'SET_POST_IMAGE';
export const SET_POSTS_ORDER_BY = 'SET_POSTS_ORDER_BY';
export const SET_COMMENTS = 'SET_COMMENTS';
export const SET_TOTAL_COMMENTS = 'SET_TOTAL_COMMENTS';
export const UPDATE_COMMENT_ON_LIST = 'UPDATE_COMMENT_ON_LIST';
export const CHANGE_MOBILE_SIDEBAR = 'CHANGE_MOBILE_SIDEBAR';
export const SET_USERS = 'SET_USERS';
export const SET_USERS_COUNTER = 'SET_USERS_COUNTER';
export const SET_USER_SEARCH = 'SET_USER_SEARCH';
export const SET_USERS_ORDER_BY = 'SET_USERS_ORDER_BY';
export const UPDATE_USER_STATE_ON_LIST = 'UPDATE_USER_STATE_ON_LIST';
export const SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS';
export const SET_TOTAL_USER_NOTIFICATIONS = 'SET_TOTAL_USER_NOTIFICATIONS';
export const UPDATE_READ_NOTIFICATION = 'UPDATE_READ_NOTIFICATION';
export const MARK_ALL_AS_READ_NOTIFICATION = 'MARK_ALL_AS_READ_NOTIFICATION';
export const UPDATE_USER_EMAIL_SETTINGS_ON_LIST = 'UPDATE_USER_EMAIL_SETTINGS_ON_LIST';
export const SET_COMMUNITY_USER_PROFILE = 'SET_COMMUNITY_USER_PROFILE';
export const RESET_COMMUNITY_USER_PROFILE = 'RESET_COMMUNITY_USER_PROFILE';
export const RESET_COMMENT_REPLIES = 'RESET_COMMENT_REPLIES';
export const SET_BADGES = 'SET_BADGES';
export const UPDATE_USER_BADGES_ON_LIST = 'UPDATE_USER_BADGES_ON_LIST';
export const SET_REPLYING_COMMENT = 'SET_REPLYING_COMMENT';




// WEBPACK FOOTER //
// ./src/screens/Community/store/types.js